define(["backbone", "configuration/properties", "messaging/messenger"], function (
  Backbone,
  Properties,
  Messenger,
) {
  "use strict";

  const AiResponseTransformationModel = {};

  AiResponseTransformationModel.responseTransformation = Backbone.Model.extend({
    defaults: {
      responseText: "",
      targetLocaleId: 0,
      operation: "",
    },
    url: function () {
      const kbId = Messenger.reqres.request("active:kb");
      return `${Properties.rootURL}/${kbId}/intents/transform`;
    },
  });

  return AiResponseTransformationModel;
});
